<template>
  <div class="app-container pull-auto">
    <!-- 顶部按钮 -->
    <div class="invoice-top">
      <!-- 待开票 -->
      <div class="border-b" style="height: 136px;">
        <div>待开票</div>
        <div class="ticket-info" style="text-align: center;max-width: 120px;">
          <div class="fz-20">
            <a>￥</a>
            <a class="numcolor">{{projectInvoiceCount.priceSum}}</a>
          </div>
          <div>{{projectInvoiceCount.count}}个项目</div>
          <div class="info-btn" @click="toRequestInvoice" style="width: 100px;">发票索取</div>
        </div>
      </div>
      <div style="display: flex;">
        <!-- 发票信息 -->
        <div class="ticket-info border-b">
          <div class="ticket-info-title">发票信息</div>
          <div class="info-detail" v-if="JSON.stringify(companyInfo)!='{}'">
            <div>发票抬头：{{companyInfo.name}}</div>
            <div>税务登记证号：{{companyInfo.taxNum}}</div>
          </div>
          <div v-else style="height: 56px;width: 200px;">
            平台管理员无此信息
          </div>
          <div class="info-btn" @click="showTicketInfo" data-type='info'>管理发票信息</div>
        </div>
        <!-- 默认寄送地址 -->
        <div class="ticket-info border-b">
          <div class="ticket-info-title">默认寄送地址</div>
          <div class="info-detail" v-if="JSON.stringify(defaultAddress)!='{}'">
            <div>
              <span>{{defaultAddress.contacts}} </span>
              <span> {{defaultAddress.phone}}</span>
            </div>
            <div>
              <span>{{defaultAddress.provinceName}} {{defaultAddress.cityName}} {{defaultAddress.areaName}} {{defaultAddress.addressee}} </span>
            </div>
          </div>
          <div v-else style="height: 56px;width: 200px;">
            暂无默认地址信息
          </div>
          <div class="info-btn" @click="showTicketInfo" data-type='address'>管理发票寄送地址</div>
        </div>
      </div>
    </div>

    <el-form :inline="true" class="demo-form-inline">
        <el-row class="rowStyle borderBottomStyle">
          <el-col :span="24">
            <el-form-item label="开票时间" class="searchdata">
              <el-date-picker v-model="form.time" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
                style="width:160px;">
              </el-date-picker>
            </el-form-item>
            <el-button @click.native="searchList" size="medium" icon="el-icon-search" type="primary">搜索</el-button>
          </el-col>
        </el-row>
        <el-row class="rowStyle">
          <el-col :span="24">
            <avue-crud :data="tableData" :option="ticketTableOption" :page="page" @size-change="sizeChange" @current-change="currentChange"
              @search-reset="searchReset" @row-click="invoiceRow" class="avue-table-self">
              <template slot-scope="scope" slot="menuLeft" class="top-btn">
                <el-button @click="ticketDetail" :disabled="checkInvListDetail" size="mini" icon="el-icon-view" type="primary">查看详情</el-button>
                <el-button @click="exportExcel" size="mini" icon="el-icon-receiving" type="primary">导出</el-button>
              </template>
              <template slot-scope="scope" slot="projectIds">
                <el-radio class="radio" v-model="resInvRowradio" :label="scope.row.projectIds"></el-radio>
              </template>
            </avue-crud>
          </el-col>
        </el-row>
    </el-form>

    <el-form :inline="true" class="projectinticket">
      <el-dialog title="发票详情" :visible.sync="projectInTicket" width="70%" >
        <el-row class="rowStyle borderBottomStyle">
          <el-col :span="24">
            <el-form-item label="项目信息">
              <el-input placeholder="请输入项目名称" v-model="proCondition" clearable></el-input>
            </el-form-item>
            <el-button @click.native="searchListPro" size="medium" icon="el-icon-search" type="primary">搜索</el-button>
          </el-col>
        </el-row>
        <el-row class="rowStyle">
          <el-col :span="24">
            <avue-crud :data="projectInTicketData" :option="projectInTicketTable"
              @search-reset="searchReset" @row-click="showRow" class="avue-table-self">
              <template slot-scope="scope" slot="menuLeft" class="top-btn">
                <el-button @click="userSee" :disabled="checkDetail" size="mini" icon="el-icon-view" type="primary">查看详情</el-button>
              </template>
              <template slot-scope="scope" slot="projectId">
                <el-radio class="radio" v-model="radio" :label="scope.row.projectId"></el-radio>
              </template>
            </avue-crud>
          </el-col>
        </el-row>
      </el-dialog>
    </el-form>
    <!-- 发票地址管理 -->
    <el-dialog title="发票地址管理" :visible.sync="ticketListVisible">
      <avue-crud :data="ticketTableData" :option="ticketOption" @row-click="invoiceAddsRow">
        <template slot-scope="scope" slot="menuLeft">
          <el-button @click="showTicketManage" data-type='add' size="mini" icon="el-icon-plus" type="primary">新增</el-button>
          <el-button @click="showTicketManage" data-type='edit' :disabled="checkinvoiceDetail" size="mini" icon="el-icon-edit"
            type="primary">修改</el-button>
          <el-button @click="showTicketManage" data-type='delete' :disabled="checkinvoiceDetail" size="mini" icon="el-icon-delete"
            type="primary">删除</el-button>
          <el-button @click="showTicketManage" data-type='default' :disabled="checkinvoiceDetail" size="mini" icon="el-icon-aim"
            type="primary">设为默认地址</el-button>
        </template>
        <template slot-scope="scope" slot="id">
          <el-radio class="radio" v-model="invoiceRadio" :label="scope.row.id"></el-radio>
        </template>
      </avue-crud>
    </el-dialog>

    <!-- 发票信息管理 弹窗 -->
    <el-form>
      <el-dialog title="发票信息管理" :visible.sync="ticketInfoVisible" width="600px" class="ticketmanage">
        <el-form>
          <el-row>
            <el-col :span="5">税务登记证号：</el-col>
            <el-col :span="19">{{companyInfo.name}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">税务登记证号：</el-col>
            <el-col :span="19">{{companyInfo.taxNum}}</el-col>
          </el-row>
          <el-row style="color: rgba(255,153,0,1);padding-left: 19px;">
            温馨提示:如需开增值税专用发票请填写以下信息
          </el-row>

          <el-row>
            <el-col :span="5">开户银行名称：</el-col>
            <el-col :span="19">
              <el-input placeholder="请填写您开户许可证上的开户银行" type="text" v-model="openingBank"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">基本开户账号：</el-col>
            <el-col :span="19">
              <el-input placeholder="请填写您开户许可证上的银行账号" type="tel" v-model="bankAccount"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">注册场所地址：</el-col>
            <el-col :span="19">
              <el-input placeholder="请填写您营业执照上的注册地址" type="text" v-model="address"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">注册固定电话：</el-col>
            <el-col :span="19">
              <el-input placeholder="请填写您公司的联系电话" type="tel" v-model="telephone"></el-input>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelUpdata">取消</el-button>
          <el-button @click="updateInvoices">确定</el-button>
        </div>
      </el-dialog>
    </el-form>

    <!-- 发票地址管理 弹窗 -->
    <el-form>
      <el-dialog :title='isAdd?"新增地址":"修改地址"' :visible.sync="ticketManageVisible" width="600px">
        <el-form class="ticketmanage">
          <el-row>
            <el-col :span="5">收件人：</el-col>
            <el-col :span="19">
              <el-input placeholder="请输入姓名" type="text" v-model="ticketForm.name" clearable></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">选择地区：</el-col>
            <el-col :span="19">
              <el-select v-model="ticketForm.thisProvince" value-key="code" clearable placeholder="请选择省份"
                @change="provinceChange">
                <el-option v-for="item in ticketForm.provinces" :key="item.code" :label='item.name' :value="item">
                </el-option>
              </el-select>
              <el-select v-model="ticketForm.thisCity" value-key="code" clearable placeholder="请选择城市"
                @change="cityChange" @visible-change="cityChange">
                <el-option v-for="item in ticketForm.city" :key="item.code" :label='item.name' :value="item">
                </el-option>
              </el-select>
              <el-select v-model="ticketForm.thisDistrict" clearable placeholder="请选择区"
                @change="areaChange" @visible-change="areaChange">
                <el-option v-for="item in ticketForm.district" :key="item.code" :label='item.name' :value="item">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">详细地址：</el-col>
            <el-col :span="19">
              <el-input placeholder="请输入详细地址" v-model="ticketForm.address"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">联系电话：</el-col>
            <el-col :span="19">
              <el-input placeholder="请输入联系电话" type="tel" maxlength="11" v-model="ticketForm.phone"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">邮政编码(选填)：</el-col>
            <el-col :span="19">
              <el-input placeholder="请输入邮政编码" type="tel" maxlength="6" v-model="ticketForm.zipCode"></el-input>
            </el-col>
          </el-row>
          <!-- <el-checkbox v-model="ticketForm.isDefault" :disabled="ticketForm.isDefault"
          style="padding-left: 14px;">{{ticketForm.isDefault?"默认地址":"设为默认地址"}}</el-checkbox> -->
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="ticketManageVisible = false">取消</el-button>
          <el-button @click="quertok">确定</el-button>
        </div>
      </el-dialog>
    </el-form>

    <!--任务详情-->
    <orderinfo2 ref="child" @refresh="refresh"></orderinfo2>
  </div>
</template>

<script>
  import {
    getProjects,
    getProjectInvoiceCount,
    exportInvoices
  } from '@/api/admin/financeManagement'
  import {
    getAllProvince,
    getCityForProvinceCode
  } from '@/api/admin/estimate'
  import {
    getDateStr
  } from "@/util/date";
  import {
    getAllInvoiceAddress,
    addInvoiceAddress,
    getCompanyInvoiceInfo,
    updateCompanyInvoiceInfo,
    updateInvoiceAddress,
    updateDefaultAddress,
    deleteAddress,
    projectInvoice
  } from '@/api/admin/invoiceManagement'
  import {
    billOption,
    ticketOption,
    ticketTableOption,
    projectInTicketTable
  } from '@/const/asset/base/manufacturerinfo'
  import {
    objKeySort
  } from '@/util/ajaxsign'
  import orderinfo2 from '../../orderManager/orderinfo2.vue'
  import '../../../styles/table.css';
  export default {
    name: 'invoiceManagement',
    components: {
      orderinfo2
    },
    data() {
      return {
        activeName: 'frist',
        companyInfo: {}, //企业信息
        listQuery: {
          current: 1,
          size: 10,
          total: 0,
        },
        // 搜索
        form: {
          time: '',
          state: '',
          condition: '',
          invoiceState: ''
        },
        projectInTicket:false,//发票中的项目
        tempData:[],//临时 保存数据
        ticketForm: {
          name: '',
          address: '',
          phone: '',
          isDefault: false,
          zipCode: '',
          thisProvince: '',
          thisCity:'',
          thisDistrict: '',
          provinceCode:'',
          cityCode:'',
          districtCode:'',
          provinces: [],
          city: [],
          district: [],
          mail: ''
        },
        proCondition:'',//发票 中包含项目搜索
        loading: false,
        address: '',
        bankAccount: '',
        openingBank: '',
        telephone: '',
        state: [{
            label: "全部",
            value: "-1"
          },
          {
            label: "已支付",
            value: "0"
          },
          {
            label: "未支付",
            value: "1"
          }
        ],
        ticketListVisible: false, //发票管理 窗口
        ticketManageVisible: false, //修改发票 窗口
        ticketInfoVisible: false, //发票信息管理
        ticketTableData: [], //发票地址管理数据
        projectInTicketData:[],//发票详情数据
        projectInvoiceCount:{},//企业待开票数据
        defaultAddress:{},//默认发票地址
        stopFalse: {},
        radio: '',
        resInvRowradio:'',//发票行radio
        invoiceRadio: '',
        selectedRow: {}, //选择的行数据
        resInvRow:{},// 发票列表行 数据
        checkDetail: true,//按钮禁用开关
        checkInvListDetail:true,// 发票列表 按钮 禁用
        checkinvoiceDetail: true,
        add: false,
        tableData: [],
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableLoading: false,
        billTableOption: billOption,
        ticketOption: ticketOption,
        ticketTableOption:ticketTableOption,
        projectInTicketTable:projectInTicketTable,
        userInfo: '',
        isAdmin: false,
        isAdd: false, //是否是删除操作
        mdata: {},//搜索条件
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }

      }
    },
    created() {
      this.getcompany();
      this.getProjectInvoiceCount();
      this.getAllInvoiceAddress();
      this.getList();
    },
    mounted: function() {},
    computed: {},
    methods: {
      //刷新列表操作
      refresh() {
        this.getList();
        this.checkDetail = true;
        this.checkinvoiceDetail = true;
      },

      // 查看工程详情
      userSee() {
        this.$refs.child.setsataus(this.radio, this.cancelStateus, true);
      },
      ticketDetail(){
        let that=this
        that.getProjectsInTicket();
        that.projectInTicket=true;
      },
      //查询 此发票中的项目
      getProjectsInTicket(){
        let that=this
        getProjects(objKeySort({projectIds:that.resInvRowradio})).then(response=>{
          if(response.data.code==200){
            that.projectInTicketData=response.data.data
          }
        })
      },
      //搜索 发票中项目 前端搜索
      searchListPro(){
        let that=this
        if(that.tempData.length>0){
          that.projectInTicketData=JSON.parse(JSON.stringify(that.tempData));
        }else{
          that.tempData=JSON.parse(JSON.stringify(that.projectInTicketData));
        }
        if(that.proCondition===''){
          that.projectInTicketData=JSON.parse(JSON.stringify(that.tempData));
          return
        }
        that.projectInTicketData.slice().reverse().forEach((item, index, object) => {
          if(item.projectName.indexOf(that.proCondition)<0){
            that.projectInTicketData.splice(object.length - 1 - index, 1);
          }
        })
      },
      showRow(row) {
        this.radio = row.projectId;
        this.handleRowClick(row);
      },
      invoiceRow(row){
        this.resInvRowradio = row.projectIds;
        this.handleResInvRowClick(row);
      },
      invoiceAddsRow(row) {
        this.invoiceRadio = row.id;
        this.handleinvoiceRowClick(row);
      },
      // 获取当前行数据
      handleRowClick(row) {
        let that = this
        if (row) {
          that.checkDetail = false
        } else {
          that.checkDetail = true
        }
      },
      // 获取当前行数据
      handleinvoiceRowClick(row) {
        let that = this
        that.selectedRow = row;
        if (row) {
          that.checkinvoiceDetail = false
        } else {
          that.checkinvoiceDetail = true
        }
      },
      //获取发票列表 行数据
      handleResInvRowClick(row){
        let that = this
        that.resInvRow = row;
        if (row) {
          that.checkInvListDetail = false
        } else {
          that.checkInvListDetail = true
        }
      },

      // 提交搜索
      searchList() {
        let that = this
        that.getList();
      },
      //清空收缩条件
      searchReset() {
        this.form = {};
        this.listQuery.current = 1;
        this.listQuery.size = 10;
        this.getList();
      },
      getList() {
        let that = this
        that.tableLoading = true;
        that.radio = undefined;
        that.invoiceRadio = undefined;

        that.mdata.pageNum = that.listQuery.current;
        that.mdata.companyName = that.companyInfo.name;
        that.mdata.state = '';
        that.mdata.pageSize = that.listQuery.size;

        if (that.form.time) {
          that.mdata.startDate = that.form.time[0];
          that.mdata.stopDate = that.form.time[1];
        }
        projectInvoice(objKeySort(that.mdata)).then(response => {
          if (response.data.code == 200) {
            that.tableData = response.data.data.rows
            that.page.total = response.data.data.total
          }
          that.tableLoading = false
        })
      },
      //获取 企业待开票数
      getProjectInvoiceCount(){
        let that=this
        getProjectInvoiceCount(objKeySort({})).then(response=>{
          if (response.data.code == 200) {
            that.projectInvoiceCount = response.data.data
          }
        })
      },
      sizeChange(val) {
        this.listQuery.size = val;
        this.page.pageSize = val;
        this.listQuery.current = 1;
        this.getList()
      },
      currentChange(val) {
        this.listQuery.current = val;
        this.page.currentPage = val;
        this.getList()
      },

      //获取个人信息
      getcompany() {
        let that = this
        that.userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
        if(that.userInfo.id!=1){
          let company = that.userInfo.company != null ? that.userInfo.company : undefined;
          if (company != undefined) {
            if (company.userId == that.userInfo.id) {
              that.isAdmin = true;
            }
          }
          that.companyInfo = company
        }else{
          that.companyInfo={}
        }

      },

      //查询状态 0未开票 1已开票 2申请中
      handleProjectStateChange(tab) {
        let that = this
        that.mdata = {}
        if (tab.name == '0') {
          that.mdata.invoiceState = 0;
          that.getList();
        } else if (tab.name == '1') {
          that.mdata.invoiceState = 1;
          that.getList();
        } else {
          that.mdata.invoiceState = 2;
          that.getList();
        }
      },
      // 跳转发票索取页
      toRequestInvoice() {
        let that = this;
        that.$router.push("/finance/invoiceRequest");
      },
      //弹窗 显示
      showTicketInfo(e) {
        let that = this;
        if (e.currentTarget.dataset.type == 'info') {
          // 获取企业开票信息
          that.ticketInfoVisible = true;
          that.address = '';
          that.bankAccount = '';
          that.openingBank = '';
          that.telephone = '';
          that.getCompanyInvoiceInfo();
        } else {
          that.ticketListVisible = true;
          that.invoiceRadio = undefined;
          that.checkinvoiceDetail = true;
          that.getAllInvoiceAddress();
        }
      },
      //获取所有发票地址信息
      getAllInvoiceAddress() {
        let that = this
        getAllInvoiceAddress(objKeySort({})).then(response => {
          if (response.data.code == 200) {
            that.ticketTableData = response.data.data;
            response.data.data.forEach(item=>{
              if(item.isDefault==1){
                that.defaultAddress = item;
              }
            })
          }
        })
      },

      //获取企业开票信息
      getCompanyInvoiceInfo() {
        let that = this;
        getCompanyInvoiceInfo(objKeySort({})).then(response => {
          if (response.data.code == 200) {
            that.address = response.data.data.address;
            that.bankAccount = response.data.data.bankAccount;
            that.openingBank = response.data.data.openingBank;
            that.telephone = response.data.data.telephone;
          }
        })
      },

      // 发票管理 弹窗
      showTicketManage(e) {
        let that = this;
        //新增
        that.ticketForm.type = e.currentTarget.dataset.type;
        if (e.currentTarget.dataset.type == 'add') {
          that.isAdd = true;
          that.ticketForm.name = '';
          that.ticketForm.phone = '';
          that.ticketForm.provinceCode = '';
          that.ticketForm.thisProvince = '';
          that.ticketForm.cityCode = '';
          that.ticketForm.thisCity = '';
          that.ticketForm.city.length = 0;
          that.ticketForm.districtCode = '';
          that.ticketForm.thisDistrict = '';
          that.ticketForm.zipCode = '';
          that.ticketForm.address = '';
          that.ticketForm.isDefault = false;
          that.getAllProvinceList();

        } else if (e.currentTarget.dataset.type == 'edit') {
          that.isAdd = false;
          //回显数据
          that.ticketForm.name = that.selectedRow.contacts;
          that.ticketForm.phone = that.selectedRow.phone;
          that.ticketForm.thisProvince = that.selectedRow.provinceName;
          that.ticketForm.thisCity = that.selectedRow.cityName;
          that.ticketForm.thisDistrict = that.selectedRow.areaName;
          that.ticketForm.mail = that.selectedRow.mail;
          that.ticketForm.address = that.selectedRow.addressee;
          that.ticketForm.zipCode = that.selectedRow.zipCode;
          that.ticketForm.isDefault = that.selectedRow.isDefault == 1 ? true : false;

          that.ticketForm.provinceCode = that.selectedRow.provinceCode;
          that.ticketForm.cityCode = that.selectedRow.cityCode;
          that.ticketForm.districtCode = that.selectedRow.areaCode;
          that.getAllProvinceList();
        } else if (e.currentTarget.dataset.type == 'delete') {
          that.deleteAddress();
        } else {
          //设为默认地址
          that.updateDefaultAddress(that.selectedRow.id)
        }
      },
      //更新默认地址
      updateDefaultAddress(id) {
        let that = this
        updateDefaultAddress(objKeySort({
          id: id
        })).then(response => {
          if (response.data.code == 200) {
            that.$notify({
              title: '温馨提示',
              message: '修改发票默认地址成功',
              type: 'success'
            });
            that.getAllInvoiceAddress();
          }
        })
      },
      //删除 发票地址
      deleteAddress() {
        let that = this
        that.$confirm('确认要删除此发票地址?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteAddress(objKeySort({
            id: that.selectedRow.id
          })).then(response => {
            if (response.data.code == 200) {
              that.$notify({
                title: '温馨提示',
                message: '删除发票地址成功',
                type: 'success'
              });
              that.getAllInvoiceAddress();
            }
          })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //查询 所有省份
      getAllProvinceList() {
        let that = this
        let data = {}
        getAllProvince(objKeySort(data)).then(response => {
          if (response.data.code == 200 && response.data.data) {
            that.ticketForm.provinces = response.data.data;
            that.ticketManageVisible = true;
          }
        })
      },
      // 省份code  获取查询下级城市
      provinceChange(e) {
        let that = this
        that.ticketForm.city.length=0;
        that.ticketForm.thisCity='';
        that.ticketForm.thisDistrict='';
        if (e.code) {
          that.ticketForm.provinceCode = e.code;
          that.ticketForm.thisProvince=e.name;
        }
        getCityForProvinceCode(objKeySort({
          pcode: e.code ? e.code : that.ticketForm.provinceCode
        })).then(response => {
          if (response.data.code == 200 && response.data.data) {
            that.ticketForm.city = response.data.data
          }
        })
      },

      //获取 城市code 地区
      cityChange(e) {
        let that = this;
        that.ticketForm.district.length=0;
        that.ticketForm.city.length=0;
        that.ticketForm.thisDistrict='';
        if (e) {
          if (e.code) {
            that.ticketForm.cityCode = e.code;
            that.ticketForm.thisCity=e.name;
            that.loading = true;
            getCityForProvinceCode(objKeySort({
              pcode: e.code
            })).then(response => {
              if (response.data.code == 200 && response.data.data) {
                that.loading = false;
                that.ticketForm.district = response.data.data;
              }
            })
          } else { //如果是 回显数据进行选择
            that.loading = true;
            if (that.ticketForm.provinceCode) {
              getCityForProvinceCode(objKeySort({
                pcode: that.ticketForm.provinceCode
              })).then(response => {
                if (response.data.code == 200 && response.data.data) {
                  that.loading = false;
                  that.ticketForm.city = response.data.data
                }
              })
            }
          }
        }
      },
      //地区 选择
      areaChange(e) {
        let that = this
        if (e) {
          if (e.code) {
            that.ticketForm.cityCode = e.code;
            that.ticketForm.thisDistrict=e.name;
          } else { //如果是 回显数据进行选择
            that.loading = true;
            if (that.ticketForm.cityCode) {
              getCityForProvinceCode(objKeySort({
                pcode: that.ticketForm.cityCode
              })).then(response => {
                if (response.data.code == 200 && response.data.data) {
                  that.loading = false;
                  that.ticketForm.district = response.data.data
                }
              })
            }
          }
        }

      },
      //新增 发票地址
      addInvoiceAddress() {
        let that = this
        addInvoiceAddress(objKeySort({})).then(response => {
          if (response.data.code == 200) {
            that.ticketTableData = response.data.data.rows
          }
        })
      },

      quertok() {
        let that = this;
        let regFormat = /^[1][3456789][0-9]{9}$/; //正确手机号
        if (!that.ticketForm.phone) {
            that.$message({
              message: '请输入手机号',
              type: 'warning'
            });
            return
        }
        if (!(regFormat.test(that.ticketForm.phone))) {
           that.$message({
             message: '手机号输入格式有误,请检查',
             type: 'warning'
           });
           return
        }

        let pattern =  /^[1-9]\d{5}$/;
        if(that.ticketForm.zipCode){
          if(!(pattern.test(that.ticketForm.zipCode))){
            that.$message({
              message: '邮政编码输入格式有误,请检查',
              type: 'warning'
            });
            return;
          }
        }

        let data = {
          cityCode: that.ticketForm.cityCode,
          addressee: that.ticketForm.address,
          cityName: that.ticketForm.thisCity,
          contacts: that.ticketForm.name,
          provinceCode: that.ticketForm.provinceCode,
          provinceName: that.ticketForm.thisProvince,
          areaName: that.ticketForm.thisDistrict,
          areaCode: that.ticketForm.districtCode,
          phone: that.ticketForm.phone,
          zipCode: that.ticketForm.zipCode
        }

        if (that.ticketForm.type == 'add') {
          addInvoiceAddress(objKeySort(data)).then(response => {
            if (response.data.code == 200) {
              that.ticketManageVisible = false;
              that.$notify({
                title: '温馨提示',
                message: '添加企业发票地址信息成功',
                type: 'success'
              });
              that.selectedRow = {};
              that.invoiceRadio = undefined;
              that.checkinvoiceDetail = true;
              that.getAllInvoiceAddress();
            }
          })
        } else {
          data.id = that.invoiceRadio;
          updateInvoiceAddress(objKeySort(data)).then(response => {
            if (response.data.code == 200) {
              that.ticketManageVisible = false;
              that.$notify({
                title: '温馨提示',
                message: '修改企业发票地址信息成功',
                type: 'success'
              });
              that.selectedRow = {};
              that.invoiceRadio = undefined;
              that.checkinvoiceDetail = true;
              that.getAllInvoiceAddress();
            }
          })
        }
      },

      //更新企业发票信息
      updateInvoices() {
        let that = this;
        let data = {
          address: that.address,
          bankAccount: that.bankAccount,
          openingBank: that.openingBank,
          telephone: that.telephone
        }
        updateCompanyInvoiceInfo(objKeySort(data)).then(response => {
          if (response.data.code == 200) {
            that.$notify({
              title: '温馨提示',
              message: '修改企业发票信息成功',
              type: 'success'
            });
            that.ticketInfoVisible = false
          }
        })
      },
      cancelUpdata() {
        this.ticketInfoVisible = false
      },
      //导出 Excel
      exportExcel() {
        let that=this
        that.tableLoading = true;
        that.radio = undefined;
        that.invoiceRadio = undefined;

        that.mdata.pageNum = that.listQuery.current;
        that.mdata.companyName = that.companyInfo.name;
        that.mdata.state = '';
        that.mdata.pageSize = that.listQuery.size;

        if (that.form.time) {
          that.mdata.startDate = that.form.time[0];
          that.mdata.stopDate = that.form.time[1];
        }

        exportInvoices(objKeySort(that.mdata)).then(res=>{
          if(res.status==200){
             let blob = new Blob([res.data], { type: "application/vnd.ms-excel" } )
             let fileName = '发票管理'+getDateStr(new Date().getTime(),0,1) + '.xlsx';
             if (window.navigator.msSaveOrOpenBlob) {
               navigator.msSaveBlob(blob, fileName);
             }else {
               let link = document.createElement('a')
               link.href = URL.createObjectURL(blob);
               link.download = fileName;
               document.body.appendChild(link);
               link.click()
             }
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .el-table {
    margin-top: 22px;
  }

  .el_s_left {
    float: left
  }

  .el_btn {
    clear: both;
  }

  .filter-item1 {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0 !important;
    margin-left: 0 !important;
    margin-right: 22px;
  }

  .el-radio__label {
    display: none;
  }

  .sh_tip {
    vertical-align: top;
    display: inline-block
  }

  .lf_item span:first-child {
    display: inline-block;
    width: 100px;
    vertical-align: top;
  }

  .el-form-items {
    float: left;
    width: 48% !important;
  }

  .el-form-itemss {
    width: 300px !important;
    height: 40px !important;
    background-attachment: #fff !important;
  }

  .el-form-itemss .el-input {
    outline: none !important;
  }

  .el-f-item {
    width: 100% !important;
  }

  .el-dialog__header {
    margin-bottom: 0px;
  }

  .el-tag {
    border: 0 !important;
    color: #666 !important;
    background-color: transparent;
    font-size: 14px;
  }

  .dialog-footer {
    margin-left: 0 !important;
  }

  .filter-item1 {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0 !important;
    margin-left: 0 !important;
    margin-right: 22px;
  }

  .is-required {}

  .el-dialog__footer {
    height: 120px;
  }

  .p1 {
    width: 100% !important;
  }

  .part {
    position: relative;
  }

  .el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }

  .avue-crud ::v-deep .avue-crud__left {
    display: flex;
  }

  .ticketmanage {
    .el-select,
    .el-row {
      margin-bottom: 14px;
    }

    .el-col-4 {
      text-align: center;
    }
  }

  .borderBottomStyle ::v-deep .el-form-item {
    margin-bottom: 0;
  }

  .wait-ticket {
    position: relative;
  }

  .wait-ticket .info-btn {
    position: absolute;
    bottom: 0;
    right: 55px;
    max-width: 80px;
  }

  .ticketmanage ::v-deep input::placeholder {
    color: #606266;
  }

  .projectinticket ::v-deep .el-dialog{
    margin-top: 10vh !important;
  }
  ::v-deep .el-col-5{
    text-align: right;
  }
  ::v-deep input::-webkit-outer-spin-button, ::v-deep input::-webkit-inner-spin-button{
     -webkit-appearance: none !important;
     appearance: none !important;
     margin: 0;
  }

  ::v-deep input[type="number"]{
   -moz-appearance:textfield;
   }
   .fz-20 a{
     color: #ff5543;
     text-decoration: none;
     font-size: 14px;
   }
   .fz-20{
     text-align: left;
     line-height: 26px;
   }
   .numcolor{
     font-size: 20px !important;
   }
</style>
